import { DataGridLoader, useDataGrid } from '.';

const DataGridEmpty = () => {
  const { table, props, loading } = useDataGrid();
  const totalColumns = table.getAllColumns().length + (props.rowSelection ? 1 : 0);

  return loading ? (
    <tr>
      <td colSpan={totalColumns} className="relative text-center py-8">
        <DataGridLoader />
      </td>
    </tr>
  ) : (
    <tr>
      <td colSpan={totalColumns} className="text-center text-muted-foreground py-6">
        {props.messages?.empty || 'No data available'}
      </td>
    </tr>
  );
};

export { DataGridEmpty };
